export default __webpack_public_path__ + "static/media/ICONO_DATOS_white.5068a821.svg";